export default __webpack_public_path__ + "static/media/daft-punk-2.3705268e.png";